module.exports = "<h2>\n  <span class=\"point no-margin\" [ngStyle]=\"{background: color}\"></span>\n\n  Rain Sensor\n</h2>\n\n<ul class=\"feature oneline\">\n  <li *ngFor=\"let key of objectKeys(rainSensors)\">\n    <park-rain-sensor-item [rainSensor]=\"rainSensors[key]\" [rainSensorId]=\"key\" [parkId]=\"parkId\" [id]=\"id\"></park-rain-sensor-item>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/controls/others/rain_sensor/park-rain-sensor-controls.html
// module id = ./src/app/dashboard/parks/park/controls/others/rain_sensor/park-rain-sensor-controls.html
// module chunks = main